import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  n: 'Tomo 1',
  title: 'Las Primeras Preguntas',
  sub: 'Cómo iniciar cualquier sesión y generar confianza desde los primeros minutos.',
  desc: 'Aprende a romper el hielo, crear rapport rápidamente y descubrir el verdadero motivo de consulta desde el inicio.'
}, {
  n: 'Tomo 2',
  title: 'Las Preguntas que Llegan al Origen',
  sub: 'Explora trauma, infancia y heridas emocionales sin perder el rumbo de la sesión.',
  desc: 'Conduce conversaciones profundas para identificar el origen emocional del problema sin desorganizar el proceso terapéutico.'
}, {
  n: 'Tomo 3',
  title: 'Las Preguntas que Revelan los Vínculos',
  sub: 'Pareja, familia, apego y relaciones difíciles.',
  desc: 'Descubre preguntas diseñadas para explorar patrones relacionales, conflictos familiares y dinámicas de apego que muchas veces permanecen ocultas.'
}, {
  n: 'Tomo 4',
  title: 'El Arte de Desbloquear al Paciente',
  sub: 'Qué preguntar cuando el paciente guarda silencio, evita responder o se resiste.',
  desc: 'Aprende cómo romper bloqueos emocionales, superar la resistencia y recuperar el rumbo de la sesión cuando parece no avanzar.'
}, {
  n: 'Tomo 5',
  title: 'Las Preguntas que Transforman Creencias',
  sub: 'Guía a tu paciente hacia nuevos significados y cambios reales.',
  desc: 'Ayuda a cuestionar creencias limitantes y acompaña procesos de cambio con preguntas que favorecen nuevas perspectivas.'
}, {
  n: 'Tomo 6',
  title: 'El Cierre que Genera Insight',
  sub: 'Cómo terminar cada sesión con claridad, reflexión y compromiso.',
  desc: 'Convierte el cierre en uno de los momentos más valiosos de la terapia, dejando preguntas que acompañen al paciente incluso después de salir del consultorio.'
}];
export function TomosSection() {
  return <section className="bg-[#faf6fb] px-4 py-14" data-id="element-238" data-mp="1jzif7xfzs1nq">
      <div className="mx-auto max-w-md" data-id="element-239" data-mp="1k1v6x2bjxqdz">
        <div className="text-center" data-id="element-240" data-mp="1abmwbwwbpvlq">
          <h2 className="font-display text-3xl font-bold leading-tight text-plum" data-id="element-241" data-mp="1aalb4zllfsqa">
            ¿Qué encontrarás dentro de El Oráculo de las Preguntas?
          </h2>
          <div className="mx-auto mt-5 space-y-1 text-[15px] text-plum/70" data-id="element-242" data-mp="11c9m320dl2zy">
            <p data-id="element-243" data-mp="15ctig3d4k2l1">No es un libro de teoría.</p>
            <p data-id="element-244" data-mp="15duuob5vmv4c">No es otro manual lleno de conceptos.</p>
            <p className="font-medium text-plum" data-id="element-245" data-mp="1t2xlo9mei0bi">
              Es un sistema práctico que puedes consultar antes o durante tus sesiones para saber
              exactamente qué preguntar según el momento clínico.
            </p>
          </div>
        </div>

        <div className="mt-8 space-y-4" data-id="element-246" data-mp="1ka3r74yduud2">
          {tomos.map((t, i) => <motion.div key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="rounded-2xl border border-purple-100 bg-white p-5 shadow-sm" data-id="element-247" data-mp="1oamm57vkogjh" data-mpi={i}>
              <div className="flex items-center gap-2" data-id="element-248" data-mp="5b6jsyxclq8i">
                <span className="rounded-full bg-plum px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-249" data-mp="d51ig7qxuy3">
                  📕 {t.n}
                </span>
              </div>
              <h3 className="mt-3 font-display text-xl font-bold text-plum" data-id="element-250" data-mp="a3pxrwzy6ndu">{t.title}</h3>
              <p className="mt-1.5 text-sm font-semibold text-magenta" data-id="element-251" data-mp="3ij9mqjtl5jn3">{t.sub}</p>
              <p className="mt-2 text-sm leading-relaxed text-plum/70" data-id="element-252" data-mp="3dkq1ymqqadwb">{t.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}